import Image from 'next/image';
import Link from 'next/link';
import React, { useEffect, useRef, useState } from 'react';

export default function eventbox(props) {
  useEffect(() => {
    //alert('www');
    window.__SBSLogModuleDataLayer = window.__SBSLogModuleDataLayer || [];
  }, []);

  const handleClick_custom = (a, b, c, d) => {
    window.__SBSLogModuleDataLayer.push({
      type: 'click',
      option: {
        clickName: '이벤트 전체보기',
        clickType: 'NC',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
      },
    });
  };

  const handleClick = (a, b, c, d) => {
    //통계에 넙겨줄 값을정리한다,상단여역 pgmbox 프로그램 / 메뉴 / 플레이톡이 있음
    window.__SBSLogModuleDataLayer.push({
      type: 'click',
      option: {
        clickName: '이벤트',
        clickType: 'NC',
        value1: b.title,
        value2: '',
        value3: '',
        value4: '',
        value5: '',
      },
    });
  };

  return (
    <>
      {/* <!-- 이벤트 -->*/}
      <div className="mainContents-typeWhite">
        <div div className="contentsBlock_w">
          <div className="moduleTitleline_w">
            <h2 className="moduleTitleline-Title">{props.data.list_title}</h2>
            <a
              href={props.data.alllink_url}
              onClick={(e) => handleClick_custom(e, '', '0', 'all')}
              className="moduleTitleline-linkMore"
              style={{
                visibility:
                  props.data.alllink_yn == 'Y' &&
                  props.data.alllink_url != '' &&
                  props.data.alllink_url != null
                    ? 'visible'
                    : 'hidden',
              }}
            >
              {props.data.alllink_title}
            </a>
          </div>
          <div className={'listModule_w_event event' + props.loc_idx}>
            <div className="listModuleSlider listScrollSlider">
              {/* <!-- 리스트 -->*/}
              <div className="SliderContent swiper-wrapper">
                {props.data.contents.map((item, index) => {
                  {
                    return item.m_view_yn === 'Y' ? (
                      <>
                        <div className="listModuleItem swiper-slide">
                          <div className="moduleBoxWrap_event">
                            <a
                              href={item.link_url_m}
                              onClick={(e) =>
                                handleClick(e, item, index, '인기')
                              }
                              {...(item.link_new_yn === 'Y' && {
                                target: '_blank',
                              })}
                              className="mb_link"
                            >
                              <div className="mb_image_w">
                                <div className="mb_image_inner">
                                  <img
                                    src={item.m_img_url}
                                    className="mb_image"
                                    alt={item.m_img_attr}
                                  />
                                </div>
                              </div>
                              <div className="mb_info_w">
                                <span className="mbif_title">{item.title}</span>
                              </div>
                            </a>
                          </div>
                        </div>
                      </>
                    ) : (
                      <></>
                    );
                  }
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
